import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateUser } from "./utils";

import type { MutationConfig } from "@/lib/react-query";
import type { User } from "@/types/user";

export type UpdateUserInput = Partial<
  Omit<User, "username" | "administrative_roles" | "enabled" | "organization" | "id" | "created_at">
>;

type UseUpdateOnboardingOptions = {
  mutationConfig?: MutationConfig<(data: UpdateUserInput) => Promise<User>>;
};

export const useUpdateOnboarding = ({ mutationConfig }: UseUpdateOnboardingOptions = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: (data: UpdateUserInput) => updateUser(data),
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.setQueryData(["profile"], data);
      // also update the authenticated-user cache used by `useUser()` (react-query-auth)
      queryClient.setQueryData(["authenticated-user"], data);
      onSuccess?.(data, variables, onMutateResult, context);
    },
    ...restConfig,
  });
};
